export default __webpack_public_path__ + "static/social-turismo-abb939610d31123b7629f23331652ea5.png";